import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IUserTicketState }     from 'Redux/Slices/UserTicket/UserTicketSlice';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const downloadUserTicketPdfRequest = (state: Draft<IUserTicketState>, { type }: PayloadAction<{ id: string }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const downloadUserTicketPdfSuccess = (state: Draft<IUserTicketState>, { type }: PayloadAction) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
};

export const downloadUserTicketPdfFailure = (state: Draft<IUserTicketState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
